const searchbarClear = document.querySelector('.header.searchbar .clear')
const searchbarInput = document.querySelector('.header.searchbar .input')

if (searchbarClear) {
  searchbarClear.addEventListener('click', function() {
    searchbarInput.value = ''
    searchbarInput.focus()
  })
}
